import React from "react"
import { Card, Button } from "react-bootstrap"
import { FaDownload, FaEye, FaPencilAlt, FaTrash } from "react-icons/fa"
import { reactLocalStorage } from "reactjs-localstorage";

import Util from "../../../util/Util";
import SalesOrderAPI from "../../../api/SalesOrderAPI";
import Const from "../../../util/Constants";
import LeadConst from "../../../util/LeadConst";
import ApiUiController from "../../../controller/ApiUiController";

class BookingTabs extends React.Component {
  constructor(props) {
    super(props);

    this.model = reactLocalStorage.getObject(Const.Model).sales_order;

    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);

    this.state = {
      inApiCall: true,
      sales: [],
    };
  }

  componentDidMount() {
    this.loadSales(this.props.id);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.id !== this.props.id) {
      this.loadSales(nextProps.id);
    }
  }

  loadSales = (id) => {
    this.setState({ inApiCall: true, sales: [] });

    SalesOrderAPI.getInnerList(
      this.props.type,
      id,
      this.onReceived,
      this.onFail
    );
  };

  onReceived = (res) => {
    this.props.onCount?.('sales_order', res.count);
    this.setState({ inApiCall: false, sales: res.data });
  };

  onFail = (res) => {
    Util.showError(res?.message || 'Something went wrong');
    this.setState({ inApiCall: false });
  };

  onDelete = (id) =>
    Util.confirmAlert(
      'Delete',
      'Are you sure you want to delete?',
      'Delete',
      'No',
      () => {
        this.setState({ inApiCall: true });
        SalesOrderAPI.delete(id, this.onDeleteSuccess, this.onFail);
      }
    );

  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Booking deleted successfully', 'success');
    this.props.reload();
  };

  renderBookings = () => {
    if (!this.state.sales.length) {
      return (
        <div className="text-center text-muted py-4 w-100">
          No Bookings Found
        </div>
      );
    }

    return this.state.sales.map((item) => (
      <div className="col-xl-6 col-lg-6 col-md-12" key={item.id}>
        <Card
          className="border-0 shadow-sm h-100"
          style={{ borderRadius: 16, overflow: 'hidden' }}
        >
          <img
            src={Const.BookingTabPlaceholder}
            alt={item.project}
            style={{ width: '100%', height: 220, objectFit: 'cover' }}
          />

          <div className="p-4">
            <h5 className="fw-bold mb-1">{item.property_name ?? Util.formatINRCurrency(item.total)}</h5>

            <div className="text-muted small">Id: {item.id}</div>
            {item.property_name ? 
              <div className="text-muted small">Total: {Util.formatINRCurrency(item.total)}</div>
              : null}   
            <div className="text-muted small mb-3">Date: {Util.dateToDisplayDateTime(item.start_date)}</div>

            <div className="d-flex gap-2 flex-wrap">
              <Button size="sm" variant="primary"
                onClick={() => this.props.show(item.id, LeadConst.SalesOrder)}>
                <FaEye /> View
              </Button>

              {this.Update ? (
                <Button size="sm" variant="warning"
                  onClick={() => this.props.edit(item.id, LeadConst.SalesOrder)}>
                  <FaPencilAlt /> Edit
                </Button>
              ) : null}

              {item.pdf ? (
                <Button size="sm" variant="danger"
                  onClick={() => window.open(item.pdf, '_blank')}>
                  <FaDownload /> PDF
                </Button>
              ): null}

              {this.Delete ? (
                <Button size="sm" variant="outline-danger"
                  onClick={() => this.onDelete(item.id)}>
                  <FaTrash /> Delete
                </Button>
              ): null}
            </div>
          </div>
        </Card>
      </div>
    ));
  };

  render() {
    return (
      <ApiUiController inApiCall={this.state.inApiCall}>
        <div className="row g-4">
          {this.renderBookings()}
        </div>
      </ApiUiController>
    );
  }
}

export default BookingTabs
